import { createFileRoute } from "@tanstack/react-router";
import { MarketingIntegrationsPage } from "../components/marketing/MarketingIntegrationsPage";
import { contentHead } from "../marketing-content/head";
import { integrationsIndexPage } from "../marketing-content/integrations";

export const Route = createFileRoute("/integrations")({
  head: () => contentHead(integrationsIndexPage()),
  component: MarketingIntegrationsPage,
});
